import { DecoratorNode, $applyNodeReplacement } from 'lexical';
import * as React from 'react';
import { Suspense } from 'react';
import './scss/Embed.scss';

const EmbedComponent = React.lazy(() => import('./EmbedComponent'));

export class EmbedNode extends DecoratorNode {
  __url;
  __embedType; // 'video', 'audio', 'file'
  __width;
  __height;
  __alignment;

  static getType() {
    return 'embed';
  }

  static clone(node) {
    return new EmbedNode(node.__url, node.__embedType, node.__width, node.__height, node.__alignment, node.__key);
  }

  static importJSON(serializedNode) {
    return $createEmbedNode(
      serializedNode.url,
      serializedNode.embedType,
      serializedNode.width,
      serializedNode.height,
      serializedNode.alignment
    );
  }

  exportJSON() {
    return {
      url: this.__url,
      embedType: this.__embedType,
      width: this.__width,
      height: this.__height,
      alignment: this.__alignment,
      type: 'embed',
      version: 1,
    };
  }

  constructor(url, embedType = 'video', width, height, alignment, key) {
    super(key);
    this.__url = url;
    this.__embedType = embedType;
    this.__width = width || '100%';
    this.__height = height || (embedType === 'audio' ? 80 : 315);
    this.__alignment = alignment;
  }

  createDOM() {
    const div = document.createElement('div');
    div.className = 'embed-container';
    return div;
  }

  updateDOM() {
    return false;
  }

  isInline() {
    return false;
  }

  setWidthAndHeight(width, height) {
    const writable = this.getWritable();
    writable.__width = width;
    writable.__height = height;
  }

  getAlignment() {
    return this.__alignment;
  }

  setAlignment(alignment) {
    const writable = this.getWritable();
    writable.__alignment = alignment;
  }

  decorate() {
    return (
      <Suspense fallback={null}>
        <EmbedComponent
          url={this.__url}
          type={this.__embedType}
          nodeKey={this.getKey()}
          width={this.__width}
          height={this.__height}
          alignment={this.__alignment}
          resizable={true}
        />
      </Suspense>
    );
  }
}

export function $createEmbedNode(url, embedType, width, height, alignment) {
  return $applyNodeReplacement(new EmbedNode(url, embedType, width, height, alignment));
}

export function $isEmbedNode(node) {
  return node instanceof EmbedNode;
}
